import { useTranslations } from '@/i18n/use-translations';
import { MenuIcon } from './icons';

type Props = {
  readonly onLeadingRef: (el: HTMLDivElement | null) => void;
  readonly onTrailingRef: (el: HTMLDivElement | null) => void;
  /** Phone only: opens the nav drawer. Absent above `sm`, where the nav is on screen. */
  readonly onMenuClick?: () => void;
};

export function Topbar({ onLeadingRef, onTrailingRef, onMenuClick }: Props) {
  const t = useTranslations('pages.admin.shell');

  return (
    <header className="flex h-topbar shrink-0 items-center gap-2 border-b border-border bg-surface px-4 sm:gap-4">
      {/* Below `sm` the nav is off-canvas, so something has to be able to call
          it back. Above `sm` it is already on screen and this would be a
          control for a state that cannot exist. */}
      <button
        type="button"
        onClick={onMenuClick}
        aria-label={t('open-nav')}
        className="-ml-2 flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-text-secondary hover:bg-hover-bg sm:hidden"
      >
        <MenuIcon className="h-5 w-5" aria-hidden />
      </button>
      <div ref={onLeadingRef} className="flex min-w-0 flex-1 items-center gap-3" />
      <div ref={onTrailingRef} className="flex items-center gap-2" />
    </header>
  );
}
